import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class BrandingHTMLInjectorService {

	constructor (private _sanitizer: DomSanitizer,
		private _http: HttpClient) { }

	async getInjectableHTMLFromFile(filePath: string): Promise<SafeHtml | undefined> {
		return this._http.get(filePath, { responseType: 'text' })
			.pipe<SafeHtml>(map(html => this._sanitizer.bypassSecurityTrustHtml(this.copyScriptNodesFromHtmlString(html))))
			.toPromise()
			.catch(() => "");
	}

	/**
	 * Scripts in the injected html will be injected, but (for some reason I have not worked out) they 
	 * do not execute. For now, we copy them from the injected HTML and insert into the document header, where they 
	 * will execute. A script needs to wait until the DOM has loaded, and can use setTimeout({}, 0) to do so.
	 */
	private copyScriptNodesFromHtmlString(html: string): string {
		const parser = new DOMParser();
		const scripts = parser.parseFromString(html, 'text/html').getElementsByTagName('script');
		// hash the contents
		const hash = this.hashCode(html).toString();
		// if the script has already been injected, remove it
		const existingScriptNode = document.getElementById(hash);
		if (existingScriptNode) {
			document.body.removeChild(existingScriptNode);
		}
		for (let i = 0; i < scripts.length; i++) {
			const script = document.createElement('script');
			script.async = false;
			script.defer = true;
			script.id = hash;
			if (scripts[i].innerText.length) {
				script.innerText = scripts[i].innerText;
			}
			else {
				const src = scripts[i].getAttribute('src');
				if (src?.length) {
					script.setAttribute('src', src);
				}
			}
			document.body.appendChild(script);
		}
		return html;
	}

	/**
	 * Returns a hash code from a string
	 * @param  The string to hash.
	 * @return A 32bit integer
	 * @see http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
	 */
	private hashCode(str: string): number {
		let hash = 0;
		for (let i = 0, len = str.length; i < len; i++) {
			let chr = str.charCodeAt(i);
			hash = (hash << 5) - hash + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	}

}
